import React from 'react'
import Modal from 'modals/dialog'
import { EmojiContent } from './s'
import Content from './content'

const EmojiPicker = ({ className, salt, ...props }) => {
    const {
        show = false,
        dismiss,
        ...picker
    } = props

    salt = `modal:emoji-picker:${salt}`

    return (
        <Modal
            show={show}
            dismiss={dismiss}
            contentWrapper={EmojiContent}
            {...(className ? { contentClassName: className } : null)}
            key={salt}>
            <Content
                {...picker}
                salt={salt} />
        </Modal>
    )
}

export default EmojiPicker